// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardTableCardEmptyState_root__16Ug0","text":"DashboardTableCardEmptyState_text__3dnVk"};